import { client } from './generated/client.gen'

export const configureApiClient = () => {
  // console.debug('[API] Configuring client with baseURL:', baseURL)

  client.setConfig({
    baseURL: import.meta.env.VITE_API_URL,
    timeout: import.meta.env.VITE_API_TIMEOUT,
    headers: {
      credentials: 'same-origin'
    }
  })
}
